import {
	defineStore
} from "pinia"

import { 
	useStorage
} from '@vueuse/core'

// types
import {
	CognitoUserWithAttributes,
	User
} from '@/types'

// Create a new store instance.
export const store = defineStore("user", {
	state: () => ({ // a function that returns a fresh state
		user: useStorage('user', {
			cognitoUser: {} as CognitoUserWithAttributes
		} as User)
	}),

	getters: { // optional getters
	},

	actions: { // optional actions

	}
})
